import React, { Component } from 'react';

export class SlotSummary extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var slotList = this.props.slotList;
        var slotArray = [];
        for (var key in slotList) {
            slotArray.push({
                orderIdentifier: key,
                slot: slotList[key]
            });
            slotArray = slotArray.sort((a, b) => (a.slot > b.slot) ? 1 : -1)
        }
        return (
            <div>
                {
                    slotArray.map(function (slotInfo, idx) {
                        return (
                            <div key={slotInfo.slot}>
                                <h3>{slotInfo.slot}: {slotInfo.orderIdentifier}</h3>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}
